import apis from "../../api/api.actions";
import { parseQueryParams } from "../../api/parseParams";
let adminpath = "v1/admin";
let superadmin = "v1/superadmin";
let interadminpath = "v1/intermediate";
let publicpath = "v1/common";
//// list /////
export const admin_event_list = (data) =>
  apis
    .getDatas(`${adminpath}/events?search=${data ? data : ""}`)
    .then((res) => res);
export const is_email_registered = (data) =>
  apis.createData(`email-exists`, data).then((res) => res);

export const admin_gallery_list = (data) =>
  apis.getDatas(`${adminpath}/images`).then((res) => res);
export const admin_videos_list = (data) =>
  apis.getDatas(`${adminpath}/videos`).then((res) => res);
export const admin_eventbooking_list = (status, search, active) => {
  const params = new URLSearchParams();

  if (status) params.set('status', status);
  if (search) params.set('search', search);
  if (active === true) params.set('active', 'true');

  const queryString = params.toString();
  const url = queryString ? `${adminpath}/event-booking?${queryString}` : `${adminpath}/event-booking`;

  return apis.getDatas(url).then((res) => res);
};
export const admin_eventbooking_detail = (data) =>
  apis.getDatas(`${adminpath}/event-booking/${data}`).then((res) => res);
export const admin_tender_list = (data) =>
  apis.getDatas(`${adminpath}/tenders`).then((res) => res);
export const admin_career_list = (data) =>
  apis.getDatas(`${adminpath}/career/list`).then((res) => res);
export const admin_publications_list = (data) =>
  apis.getDatas(`${adminpath}/publications`).then((res) => res);
export const admin_publications_delete = (id) =>
  apis.deleteData(`${adminpath}/publications/${id}`).then((res) => res);
export const user_company_domain_list = (data) =>
  apis.getDatas(`${publicpath}/domains-types`).then((res) => res);
export const admin_scopeact_list = (data) =>
  apis.getDatas(`${adminpath}/scope-of-activity`).then((res) => res);
export const admin_banners_list = (data) =>
  apis.getDatas(`${adminpath}/banners`).then((res) => res);
export const admin_domains_list = (data) =>
  apis.getDatas(`${adminpath}/domains-types`).then((res) => res);
export const admin_qualification_list = (data) =>
  apis.getDatas(`${publicpath}/highest-qualification`).then((res) => res);
export const admin_tenderCategory_list = (data) =>
  apis.getDatas(`${adminpath}/tender-category`).then((res) => res);
export const admin_tenderOrganization_list = (data) =>
  apis.getDatas(`${adminpath}/tender-organisation`).then((res) => res);
export const admin_notification_list = (data) =>
  apis.getDatas(`${adminpath}/notifications`).then((res) => res);
export const admin_advertisement_list = (data) =>
  apis.getDatas(`${adminpath}/advertisements/show`).then((res) => res);

export const admin_policies_list = (data) =>
  apis.getDatas(`${adminpath}/policy`).then((res) => res);
export const admin_news_list = (data) =>
  apis.getDatas(`${adminpath}/newsupdate`).then((res) => res);
export const admin_incentives_list = (data) =>
  apis.getDatas(`${adminpath}/incentive`).then((res) => res);
export const admin_accomplishment_list = (data) =>
  apis.getDatas(`${adminpath}/our-accomplishments`).then((res) => res);
export const admin_quotes_list = (data) =>
  apis.getDatas(`${adminpath}/testimonials`).then((res) => res);
export const admin_about_list = (data) =>
  apis.getDatas(`${adminpath}/about-us`).then((res) => res);
export const admin_org_list = (data) =>
  apis.getDatas(`${adminpath}/organization-structure`).then((res) => res);
export const admin_orgs = (data) =>
  apis.getDatas(`${adminpath}/org-list`).then((res) => res);
export const admin_applicationss_list = (page, per_page, filters = {}) => {
  const params = new URLSearchParams();
  params.set("page", page || 1);
  params.set("per_page", per_page || 10);
  if (filters.status) params.set("status", filters.status);
  if (filters.domain) params.set("domainsearch[]", filters.domain);
  if (filters.area_type) params.set("area_type", filters.area_type);
  return apis.getDatas(`${adminpath}/application-request-list?${params.toString()}`).then((res) => res);
};
export const admin_applications_view = (data) =>
  apis.getDatas(`${adminpath}/application-view/${data}`).then((res) => res);
export const admin_applications_search = (data) =>
  apis
    .getDatas(`${adminpath}/application_search${parseQueryParams(data)}`)
    .then((res) => res);

export const admin_app_submit = (data) =>
  apis
    .createData(`${adminpath}/application-status_update`, data)
    .then((res) => res);
export const area_allocate_submit = (data) =>
  apis.createData(`${adminpath}/area-allocations`, data).then((res) => res);

export const common_file_upload = (data) =>
  apis.createData(`${publicpath}/file/upload`, data).then((res) => res);

export const admin_msg_status_change = (id) =>
  apis.createData(`${adminpath}/read-status/${id}`).then((res) => res);
export const admin_messsage_view = (data) =>
  apis
    .getDatas(`${adminpath}/admin_application_logs/${data}`)
    .then((res) => res);
export const superadmin_messsage_view = (data) =>
  apis
    .getDatas(`${superadmin}/admin_application_logs/${data}`)
    .then((res) => res);
export const superadmin_app_submit = (data) =>
  apis
    .createData(`${superadmin}/application-status_update`, data)
    .then((res) => res);
export const superadmin_applications_view = (data) =>
  apis.getDatas(`${superadmin}/application-view/${data}`).then((res) => res);
export const superadmin_app_list = (page, per_page, filters = {}) => {
  const params = new URLSearchParams();
  params.set("page", page || 1);
  params.set("per_page", per_page || 10);
  if (filters.status) params.set("status", filters.status);
  if (filters.domain) params.set("domainsearch[]", filters.domain);
  if (filters.area_type) params.set("area_type", filters.area_type);
  return apis.getDatas(`${superadmin}/application-request-list?${params.toString()}`).then((res) => res);
};
export const superadmin_status = (data) =>
  apis.getDatas(`${superadmin}/superadmin-status/${data}`).then((res) => res);
export const company_application_response = (data) =>
  apis.getDatas(`${publicpath}/application-response/${data}`).then((res) => res);
export const application_confirm = (id, data) =>
  apis.createData(`${publicpath}/application-response/${id}/confirm`, data).then((res) => res);
export const application_suggest = (id, data) =>
  apis.createData(`${publicpath}/application-response/${id}/suggest`, data).then((res) => res);

export const admin_status = (data) =>
  apis.getDatas(`${adminpath}/admin-status/${data}`).then((res) => res);
export const dash_info = (type) =>
  apis
    .getDatas(`${type == 2 ? superadmin : adminpath}/admin-dashboard`)
    .then((res) => res);
export const cfo_dash_info = () =>
  apis.getDatas(`${adminpath}/cfo-dashboard`).then((res) => res);
export const admin_spacearea_list = (data) =>
  apis.getDatas(`${adminpath}/areas${parseQueryParams(data)}`).then((res) => res);
export const admin_buildup_list = (data) =>
  apis
    .getDatas(`${adminpath}/space-area-types/built_up_space`)
    .then((res) => res);
export const admin_basearea_list = (data) =>
  apis.getDatas(`${adminpath}/base-area`).then((res) => res);
export const admin_location_list = (data) =>
  apis.getDatas(`${adminpath}/locations`).then((res) => res);
export const admin_areatype_list = (data) =>
  apis.getDatas(`${adminpath}/built-space-types`).then((res) => res);
export const admin_rentarea_list = (data) =>
  apis.getDatas(`${adminpath}/building-rentable-areas`).then((res) => res);
export const admin_area_allocated_histoty_list = (data) =>
  apis.getDatas(`${adminpath}/area-allocations`).then((res) => res);

export const getUserStatuses = () =>
  apis.getDatas(`${adminpath}/user-status`).then((res) => res);

//////////////////////////////
///// create ///////////
export const admin_publications_create = (data) =>
  apis.createData(`${adminpath}/publications`, data).then((res) => res);
export const admin_spacearea_create = (data) =>
  apis.createData(`${adminpath}/space-area-types`, data).then((res) => res);
export const admin_domains_add = (data) =>
  apis.createData(`${adminpath}/domains-types`, data).then((res) => res);
export const admin_gallery_add = (data) =>
  apis.createData(`${adminpath}/images`, data).then((res) => res);
export const admin_videos_add = (data) =>
  apis.createData(`${adminpath}/videos`, data).then((res) => res);
export const admin_notification_add = (data) =>
  apis.createData(`${adminpath}/notifications`, data).then((res) => res);
export const admin_advertisement_add = (data) =>
  apis.createData(`${adminpath}/advertisements`, data).then((res) => res);

export const admin_policy_add = (data) =>
  apis.createData(`${adminpath}/policy`, data).then((res) => res);
export const admin_news_add = (data) =>
  apis.createData(`${adminpath}/newsupdate`, data).then((res) => res);
export const admin_incentive_add = (data) =>
  apis.createData(`${adminpath}/incentive`, data).then((res) => res);
export const admin_policy_edit = (id, data) =>
  apis.createData(`${adminpath}/policy/${id}`, data).then((res) => res);
export const admin_news_edit = (id, data) =>
  apis.createData(`${adminpath}/newsupdate/${id}`, data).then((res) => res);
export const admin_incentives_edit = (id, data) =>
  apis.createData(`${adminpath}/incentive/${id}`, data).then((res) => res);
export const admin_banner_add = (data, uuid) =>
  apis.createData(`${adminpath}/banners${uuid ? `/${uuid}` : ''}`, data).then((res) => res);
export const admin_areatype_add = (data) =>
  apis.createData(`${adminpath}/built-space-types`, data).then((res) => res);
export const admin_areatype_edit = (id, data) =>
  apis
    .updateData(`${adminpath}/built-space-types/${id}`, data)
    .then((res) => res);
export const admin_rentarea_add = (data) =>
  apis
    .createData(`${adminpath}/building-rentable-areas`, data)
    .then((res) => res);
export const admin_rentarea_edit = (id, data) =>
  apis
    .updateData(`${adminpath}/building-rentable-areas/${id}`, data)
    .then((res) => res);
export const admin_accomplishment_add = (data) =>
  apis.createData(`${adminpath}/our-accomplishments`, data).then((res) => res);
export const admin_quotes_add = (data) =>
  apis.createData(`${adminpath}/testimonials`, data).then((res) => res);
export const admin_spaceparkadvisers_add = (data) =>
  apis
    .createData(`${adminpath}/create/space-park-advisor`, data)
    .then((res) => res);
// export const admin_mous_add = (data) =>
//   apis.createData(`${adminpath}/mous`, data).then((res) => res);
export const membership_add = (data) =>
  apis.createData(`${adminpath}/memberships`, data).then((res) => res);

export const admin_scope_add = (data) =>
  apis.createData(`${adminpath}/scope-of-activity`, data).then((res) => res);
export const admin_org_add = (data) =>
  apis
    .createData(`${adminpath}/organization-structure`, data)
    .then((res) => res);
export const admin_orgstre_add = (data) =>
  apis.createData(`${adminpath}/main-category`, data).then((res) => res);
export const admin_event_add = (data) =>
  apis.createData(`${adminpath}/events`, data).then((res) => res);
// export const admin_event_booking_accept = (id) =>
//   apis.getDatas(`${adminpath}/booking-approval/${id}`).then((res) => res);
export const faq_add = (data) =>
  apis.createData(`${adminpath}/faq`, data).then((res) => res);
export const admin_event_booking_accept = (id) =>
  apis.getDatas(`${adminpath}/booking-status-update/${id}`).then((res) => res);
export const admin_event_booking_approve = (id) =>
  apis.createData(`${superadmin}/booking-approval/${id}`).then((res) => res);
export const admin_event_booking_revert = (id, data) =>
  apis
    .createData(`${superadmin}/booking-reject/${id}`, data)
    .then((res) => res);

export const admin_event_booking_submit = (id, data) =>
  apis
    .createData(`${adminpath}/booking-approval/${id}`, data)
    .then((res) => res);

export const interadmin_event_booking_accept = (id) =>
  apis.createData(`${adminpath}/booking-approval/${id}`).then((res) => res);
export const cfo_payment_accept = (id, data) =>
  apis
    .createData(`${adminpath}/booking-status-update/${id}`, data)
    .then((res) => res);

export const interadmin_event_booking_reject = (id) =>
  apis.getDatas(`${adminpath}/booking-reject/${id}`).then((res) => res);
export const admin_event_booking_reject = (id) =>
  apis.getDatas(`${adminpath}/booking-reject/${id}`).then((res) => res);
export const tech_transfer_data = () =>
  apis.getDatas(`${publicpath}/category-organization`).then((res) => res);
export const tech_tender_cat_data = () =>
  apis.getDatas(`${adminpath}/tender-category`).then((res) => res);
export const tech_tender_org_data = () =>
  apis.getDatas(`${adminpath}/tender-organisation`).then((res) => res);

export const admin_tender_add = (data) =>
  apis.createData(`${adminpath}/tenders`, data).then((res) => res);
export const admin_careers_add = (data) =>
  apis.createData(`${adminpath}/career/create`, data).then((res) => res);
export const admin_tech_prop_add = (data) =>
  apis
    .createData(`${adminpath}/technology-transfer/create`, data)
    .then((res) => res);
export const vendorPaymentInitiate = (id, data) =>
  apis
    .createData(`${publicpath}/vendors/${id}/payment-initiate`, data)
    .then((res) => res);

////////////////////////////
///// update ///////////

export const admin_spaceparkadvisers_edit = (id, data) =>
  apis
    .createData(`${adminpath}/edit/space-park-advisor/${id}`, data)
    .then((res) => res);

export const admin_membership_edit = (id, data) =>
  apis.createData(`${adminpath}/memberships/${id}`, data).then((res) => res);
// export const admin_faq_edit = (id, data) =>
//   apis.updateData(`${adminpath}/faq/${id}`, data).then((res) => res);

export const admin_spacearea_update = (id, data) =>
  apis
    .updateData(`${adminpath}/space-area-types/${id}`, data)
    .then((res) => res);

export const update_floor_name = (id, data) =>
  apis
    .updateData(
      `${adminpath}/application-area-allocations/${id}/floor-name`,
      data
    )
    .then((res) => res);
export const admin_domains_update = (id, data) =>
  apis.updateData(`${adminpath}/domains-types/${id}`, data).then((res) => res);
export const admin_qualifications_update = (id, data) =>
  apis
    .createData(`${publicpath}/highest-qualification/${id}`, data)
    .then((res) => res);
export const admin_tenderCategories_update = (id, data) =>
  apis
    .updateData(`${adminpath}/tender-category/${id}`, data)
    .then((res) => res);
export const admin_technoCatOrg_update = (id, data) =>
  apis
    .updateData(`${adminpath}/category-organization/${id}`, data)
    .then((res) => res);
export const admin_tenderOrganization_update = (id, data) =>
  apis
    .updateData(`${adminpath}/tender-organisation/${id}`, data)
    .then((res) => res);
export const admin_gallery_update = (id, data) =>
  apis.createData(`${adminpath}/images`, data).then((res) => res);
export const admin_videos_update = (id, data) =>
  apis.createData(`${adminpath}/videos`, data).then((res) => res);
export const admin_notification_update = (id, data) =>
  apis.updateData(`${adminpath}/notifications/${id}`, data).then((res) => res);
export const admin_advertisement_update = (id, data) =>
  apis.createData(`${adminpath}/advertisements/${id}`, data).then((res) => res);

export const admin_aboutus_update = (id, data) =>
  apis.updateData(`${adminpath}/about-us/${id}`, data).then((res) => res);
export const admin_banner_update = (id, data) =>
  apis.updateData(`${adminpath}/banners/${id}`, data).then((res) => res);
export const admin_faq_edit = (id, data) =>
  apis.updateData(`${adminpath}/faq/${id}`, data, {
    headers: { "Content-Type": "application/json" },
  });
export const admin_accomplishment_update = (id, data) =>
  apis
    .updateData(`${adminpath}/our-accomplishments/${id}`, data)
    .then((res) => res);

export const admin_tender_update = (id, data) =>
  apis.createData(`${adminpath}/tenders/${id}`, data).then((res) => res);
export const admin_career_update = (id, data) =>
  apis.createData(`${adminpath}/career/update/${id}`, data).then((res) => res);

export const admin_mous_edit = (id, data) =>
  apis.createData(`${adminpath}/mous/${id}`, data).then((res) => res);
export const admin_mous_add = (data) =>
  apis.createData(`${adminpath}/mous`, data).then((res) => res);
//////////////////////////
///// delete ///////////
export const admin_spacearea_delete = (data) =>
  apis
    .deleteData(`${adminpath}/space-area-types/${data}`, data)
    .then((res) => res);
export const admin_domains_delete = (data) =>
  apis.deleteData(`${adminpath}/domains-types/${data}`).then((res) => res);
export const admin_qualifications_delete = (data) =>
  apis
    .deleteData(`${superadmin}/highest-qualification/${data}`)
    .then((res) => res);
export const admin_tenderCategory_delete = (data) =>
  apis.deleteData(`${adminpath}/tender-category/${data}`).then((res) => res);
export const admin_techTransferCategory_delete = (data) =>
  apis.deleteData(`${adminpath}/category-organization/${data}`).then((res) => res);
export const admin_tenderOrganization_delete = (data) =>
  apis
    .deleteData(`${adminpath}/tender-organisation/${data}`)
    .then((res) => res);
export const admin_gallery_delete = (id) =>
  apis.deleteData(`${adminpath}/images/${id}`).then((res) => res);
export const admin_videos_delete = (id) =>
  apis.deleteData(`${adminpath}/videos/${id}`).then((res) => res);
export const admin_notification_delete = (id) =>
  apis.deleteData(`${adminpath}/notifications/${id}`).then((res) => res);
export const admin_advertisement_delete = (id) =>
  apis.deleteData(`${superadmin}/advertisements/${id}`).then((res) => res);

export const admin_policy_delete = (id) =>
  apis.deleteData(`${adminpath}/policy/${id}`).then((res) => res);
export const admin_news_delete = (id) =>
  apis.deleteData(`${adminpath}/newsupdate/${id}`).then((res) => res);
export const admin_incentives_delete = (id) =>
  apis.deleteData(`${adminpath}/incentive/${id}`).then((res) => res);
export const admin_banner_delete = (id) =>
  apis.deleteData(`${adminpath}/banners/${id}`).then((res) => res);
export const admin_areatype_delete = (id) =>
  apis.deleteData(`${adminpath}/built-space-types/${id}`).then((res) => res);
export const admin_rentarea_delete = (id) =>
  apis
    .deleteData(`${adminpath}/building-rentable-areas/${id}`)
    .then((res) => res);
export const admin_quotes_delete = (id) =>
  apis.deleteData(`${adminpath}/testimonials/${id}`).then((res) => res);
export const admin_org_delete = (id) =>
  apis
    .deleteData(`${adminpath}/organization-structure/${id}`)
    .then((res) => res);
export const admin_event_delete = (id) =>
  apis.deleteData(`${adminpath}/events-delete/${id}`).then((res) => res);
export const admin_eventbooking_delete = (id) =>
  apis.deleteData(`${adminpath}/booking-delete/${id}`).then((res) => res);
export const admin_tender_delete = (id) =>
  apis.deleteData(`${adminpath}/tenders/${id}`).then((res) => res);
export const admin_career_delete = (id) =>
  apis.deleteData(`${adminpath}/career/delete/${id}`).then((res) => res);
export const admin_advisors_delete = (data) =>
  apis
    .deleteData(`${superadmin}/delete/space-park-advisors/${data}`)
    .then((res) => res);
export const admin_mou_delete = (data) =>
  apis.deleteData(`${superadmin}/mous/delete/${data}`).then((res) => res);
export const admin_membership_delete = (data) =>
  apis
    .deleteData(`${superadmin}/memberships/delete/${data}`)
    .then((res) => res);
export const admin_faq_delete = (data) =>
  apis.deleteData(`${superadmin}/faq/${data}`).then((res) => res);

export const admin_expman_delete = (data) =>
  apis
    .deleteData(`${superadmin}/expert-man-power/delete/${data}`)
    .then((res) => res);
export const admin_cand_delete = (data) =>
  apis.deleteData(`${superadmin}/candidate/delete/${data}`).then((res) => res);

export const admin_resper_delete = (data) =>
  apis
    .deleteData(`${superadmin}/resource-person/delete/${data}`)
    .then((res) => res);
export const admin_vendor_delete = (data) =>
  apis.deleteData(`${superadmin}/vendors/${data}`).then((res) => res);

export const admin_bussprop_delete = (data) =>
  apis
    .deleteData(`${superadmin}/business-idea/delete/${data}`)
    .then((res) => res);
export const admin_techprop_delete = (data) =>
  apis
    .deleteData(`${superadmin}/technology-transfer/delete/${data}`)
    .then((res) => res);
////////////////////////////////////////////////////////////////////////
/////////////////// Detail ////////////////////////////////////////////

export const admin_event_view = (data) =>
  apis.getDatas(`${adminpath}/events/${data}`).then((res) => res);

export const admin_company_details = (data) =>
  apis.getDatas(`${adminpath}/company/${data}`).then((res) => res);
export const update_company_registration = (id, data) =>
  apis.createData(`${adminpath}/update-company/${id}`, data).then((res) => res);
export const update_company_registration_superadmin = (id, data) =>
  apis
    .createData(`${superadmin}/update-company/${id}`, data)
    .then((res) => res);

export const update_premises = (data) =>
  apis.createData(`${adminpath}/application-update`, data).then((res) => res);
export const update_premises_superadmin = (data) =>
  apis.createData(`${superadmin}/application-update`, data).then((res) => res);

export const update_academic = (id, data) =>
  apis
    .createData(`${adminpath}/institution/update/${id}`, data)
    .then((res) => res);
export const create_company_request = (data) =>
  apis.createData(`${adminpath}/create-company`, data).then((res) => res);
export const get_technology_proposal_list = (id) =>
  apis
    .getDatas(
      `${id === 1 ? adminpath : id === 2 ? superadmin : adminpath
      }/technology-transfer/list`
    )
    .then((res) => res);

export const get_project_proposal_list = (id) =>
  apis
    .getDatas(
      `${id === 1 ? adminpath : id === 2 ? superadmin : adminpath
      }/business-idea/list-proposal`
    )
    .then((res) => res);
export const get_project_proposal_details = (id) =>
  apis.getDatas(`${adminpath}/business-idea/details/${id}`).then((res) => res);

export const get_tech_proposal_details = (id) =>
  apis
    .getDatas(
      `${id === 1 ? adminpath : id === 2 ? superadmin : adminpath
      }/technology-transfer/view/${id}`
    )
    .then((res) => res);
export const get_advisorsList_listings = () =>
  apis
    .getDatas(`${adminpath}/list/space-park-advisors`)
    .then((res) => res);
export const get_advisorsList_list = (id) =>
  apis
    .getDatas(`${adminpath}/view/space-park-advisor/${id}`)
    .then((res) => res);
export const get_mou_list = (id) =>
  apis.getDatas(`${adminpath}/mous`).then((res) => res);
export const get_membership_list = (id) =>
  apis.getDatas(`${adminpath}/memberships`).then((res) => res);
export const get_challenge_opportunity_list = () =>
  apis.getDatas(`${adminpath}/challenge-opportunity`).then((res) => res);
export const admin_challenge_opportunity_create = (data) =>
  apis
    .createData(`${adminpath}/challenge-opportunity`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((res) => res);
export const admin_challenge_opportunity_update = (id, data) =>
  apis.createData(`${adminpath}/challenge-opportunity/${id}`, data).then((res) => res);
export const admin_challenge_opportunity_delete = (id) =>
  apis.deleteData(`${superadmin}/challenge-opportunity/${id}`).then((res) => res);
export const get_market_analysis_list = () =>
  apis.getDatas(`${adminpath}/market-analysis`).then((res) => res);
export const admin_market_analysis_create = (data) =>
  apis.createData(`${adminpath}/market-analysis`, data).then((res) => res);
export const get_market_analysis_details = (id) =>
  apis.getDatas(`${adminpath}/market-analysis/${id}`).then((res) => res);

export const admin_market_analysis_update = (id, data) =>
  apis.updateData(`${adminpath}/market-analysis/${id}`, data).then((res) => res);
export const admin_market_analysis_delete = (data) =>
  apis
    .deleteData(`${superadmin}/market-analysis/${data}`)
    .then((res) => res);
export const get_vendors_list = (id) =>
  apis.getDatas(`${adminpath}/vendors`).then((res) => res);

export const get_faq_list = (id) =>
  apis.getDatas(`${adminpath}/faq`).then((res) => res);

export const get_adviser_details = (id) =>
  apis
    .getDatas(
      `${id === 1 ? adminpath : id === 2 ? superadmin : adminpath
      }/view/space-park-advisor/${id}`
    )
    .then((res) => res);
export const get_mou_details = (id) =>
  apis
    .getDatas(
      `${id === 1 ? adminpath : id === 2 ? superadmin : adminpath}/mous/${id}`
    )
    .then((res) => res);
export const get_membership_details = (id) =>
  apis
    .getDatas(
      `${id === 1 ? adminpath : id === 2 ? superadmin : adminpath
      }/memberships/${id}`
    )
    .then((res) => res);

export const get_faq_details = (id) =>
  apis
    .getDatas(
      `${id === 1 ? adminpath : id === 2 ? superadmin : adminpath}/faq/${id}`
    )
    .then((res) => res);

export const update_adviser_status = (id, data) =>
  apis
    .updateData(`${superadmin}/update/space-park-advisor/${id}`, data)
    .then((res) => res);
export const mou_approve_status = (id, data) =>
  apis.createData(`${superadmin}/mous/approve/${id}`, data).then((res) => res);
export const mou_revert_status = (id, data) =>
  apis.createData(`${superadmin}/mous/revert/${id}`, data).then((res) => res);
export const membership_approve_status = (id, data) =>
  apis
    .createData(`${superadmin}/memberships/approve/${id}`, data)
    .then((res) => res);
export const challenges_approve_status = (id, data) =>
  apis
    .createData(`${superadmin}/challenge-opportunity/${id}/approve`, data)
    .then((res) => res);
export const faq_approve_status = (id, data) =>
  apis.createData(`${superadmin}/faq/approve/${id}`, data).then((res) => res);
export const advertisement_approve_status = (id, data) =>
  apis
    // .createData(`${superadmin}/advertisements/accept/${id}`, data)
    .createData(`${superadmin}/advertisements/${id}/accept`, data)
    .then((res) => res);

export const membership_revert_status = (id, data) =>
  apis
    .createData(`${superadmin}/memberships/revert/${id}`, data)
    .then((res) => res);
export const challenges_revert_status = (id, data) =>
  apis
    .createData(`${superadmin}/challenge-opportunity/${id}/reject`, data)
    .then((res) => res);
export const faq_revert_status = (id, data) =>
  apis.createData(`${superadmin}/faq/revert/${id}`, data).then((res) => res);
export const advertisement_revert_status = (id, data) =>
  apis
    .createData(`${superadmin}/advertisements/${id}/revert`, data)
    .then((res) => res);

export const update_tech_proposal_status = (admin, id, data) =>
  apis
    .updateData(
      `${admin === 1 ? adminpath : admin === 2 ? superadmin : adminpath
      }/technology-transfer/update/${id}`,
      data
    )
    .then((res) => res);

export const update_proposal_status = (data) =>
  apis
    .createData(`${adminpath}/business-idea/update-status`, data)
    .then((res) => res);
export const get_manPowerList_list = (id) =>
  apis
    .getDatas(
      `${id === 1 ? adminpath : id === 2 ? superadmin : adminpath
      }/expert-man-power/list`
    )
    .then((res) => res);
export const get_candidates_list = (id) =>
  apis
    .getDatas(`${adminpath}${id === 2 ? "/scandidate" : "/candidate"}`)
    .then((res) => res);
export const admin_candidates_list = (id) =>
  apis.getDatas(`${adminpath}$/candidate`).then((res) => res);
export const admin_candidates_employed_list = (id) =>
  apis
    .getDatas(`${publicpath}/candidates/employed-by-kspace`)
    .then((res) => res);
export const admin_candidates_inactive_list = (id) =>
  apis.getDatas(`${publicpath}/candidates/inactive`).then((res) => res);
export const admin_candidates_deactivated_list = (id) =>
  apis.getDatas(`${publicpath}/candidates/deactivated`).then((res) => res);
export const admin_downloaded_candidates_list = (id) =>
  apis.getDatas(`${adminpath}/candidates/profiles/${id}`).then((res) => res);
export const get_companyProfile_list = (id) =>
  apis.getDatas(`${adminpath}/candidates/profiles`).then((res) => res);

export const expertManPowerCreateLookup = (data) =>
  apis.getDatas(`${publicpath}/expert-man-power/look-up`).then((res) => res);

export const expertManPowerCreate = (data) =>
  apis
    .createData(`${adminpath}/expert-man-power/create`, data)
    .then((res) => res);
export const get_manpower_details = (id) =>
  apis
    .getDatas(
      `${id === 1 ? adminpath : id === 2 ? superadmin : adminpath
      }/expert-man-power/view/${id}`
    )
    .then((res) => res);
export const get_candidates_details = (id) =>
  apis.getDatas(`${publicpath}/candidate/${id}`).then((res) => res);
export const get_admin_candidates_details = (id) =>
  apis.getDatas(`${adminpath}/candidate/${id}`).then((res) => res);
export const get_admin_downloaded_candidates_details = (data) =>
  apis.createData(`${adminpath}/candidates/detail`, data).then((res) => res);

export const update_manpower_status = (data) =>
  apis.updateData(`${adminpath}/em-status`, data).then((res) => res);
export const update_jobseeker_status = (data, id) =>
  apis
    .updateData(
      `${adminpath}/candidate-certificate/status/${id}
`,
      data
    )
    .then((res) => res);
export const update_candidates_status = (data, id) =>
  apis
    .updateData(`${adminpath}/candidate-masterupdate/${id}`, data)
    .then((res) => res);
export const confirm_deactivation = (id) =>
  apis
    .createData(`${adminpath}/candidates/deactivate-confirm/${id}`)
    .then((res) => res);
export const confirm_reactivate = (id) =>
  apis
    .createData(`${adminpath}/candidates/activate-confirm/${id}`)
    .then((res) => res);
export const update_admin_candidates_status = (data, id) =>
  apis
    .updateData(`${adminpath}/candidate-update/${id}`, data)
    .then((res) => res);
export const admin_candidates_reminder = (data, id) =>
  apis
    .createData(`${adminpath}/candidates/profiles/reminder/${id}`, data)
    .then((res) => res);
export const admin_candidates_delete = (id) =>
  apis
    .deleteData(`${adminpath}/candidates/profiles/delete/${id}`)
    .then((res) => res);
export const admin_candidates_confirm = (id) =>
  apis
    .createData(`${adminpath}/candidates/profiles/confirmation/${id}`)
    .then((res) => res);

export const adminresourcePersonalCreate = (data) =>
  apis
    .createData(
      `${adminpath}/resource-person/create`,
      data
      // {
      // headers: { Authorization: null },
      // }
    )
    .then((res) => res);

export const get_resList_list = (id) =>
  apis
    .getDatas(
      `${id === 1 ? adminpath : id === 2 ? superadmin : adminpath
      }/resource-person/list`
    )
    .then((res) => res);

export const get_resourse_details = (id) =>
  apis
    .getDatas(
      `${id === 1 ? adminpath : id === 2 ? superadmin : adminpath
      }/resource-person/view/${id}`
    )
    .then((res) => res);
export const get_vendor_details = (id) =>
  apis
    .getDatas(
      `${id === 1 ? adminpath : id === 2 ? superadmin : adminpath
      }/vendors/${id}`
    )
    .then((res) => res);

export const update_resourse_status = (data) =>
  apis.updateData(`${adminpath}/rp-status`, data).then((res) => res);
export const update_resourse_resume = (data, id) =>
  apis
    .updateData(`${adminpath}/resource-person/update/${id}`, data)
    .then((res) => res);
export const update_vendor_status = (data, id) =>
  apis
    .createData(`${adminpath}/vendors/${id}/submit-for-review`, data)
    .then((res) => res);
export const vendor_cfo_revert = (data, id) =>
  apis
    .createData(`${adminpath}/vendors/${id}/payment-issue`, data)
    .then((res) => res);
export const sa_update_vendor_status = (data, id) =>
  apis
    .createData(`${superadmin}/vendors/${id}/pass-to-admin`, data)
    .then((res) => res);
export const admin_rp_resume_update = (data, id) =>
  apis
    .createData(`${adminpath}/resource-person/${id}/resume`, data)
    .then((res) => res);
export const admin_exp_resume_update = (data, id) =>
  apis
    .createData(`${adminpath}/expert-man-power/${id}/resume`, data)
    .then((res) => res);
export const sa_update_revert_status = (data, id) =>
  apis
    .createData(`${superadmin}/vendors/${id}/revert-to-admin`, data)
    .then((res) => res);
export const admin_update_revert_status = (data, id) =>
  apis
    .createData(`${adminpath}/vendors/${id}/revertedbyadmin`, data)
    .then((res) => res);
export const admin_update_revert_status_touser = (data, id) =>
  apis
    .createData(`${adminpath}/vendors/${id}/revert-to-user`, data)
    .then((res) => res);

export const cfo_update_payment_status = (data, id) =>
  apis
    .createData(`${adminpath}/vendors/${id}/approve-for-payment`, data)
    .then((res) => res);
export const admin_final_acceptance_status = (data, id) =>
  apis
    .createData(`${adminpath}/vendors/${id}/finalacceptance`, data)
    .then((res) => res);
///////////////////////////////////////////////////////////////////////////

export const user_company_list = (data) =>
  apis
    .getDatas(`v1/admin/companies${parseQueryParams(data)}`)
    .then((res) => res);

export const user_company_status = (data) =>
  apis.updateData(`${adminpath}/company-status`, data).then((res) => res);

export const institutions_list = (data) =>
  apis.getDatas(`${adminpath}/institutions`).then((res) => res);
export const institutions_detail = (data) =>
  apis.getDatas(`${adminpath}/institution/${data}`).then((res) => res);
export const institutions_status_update = (data) =>
  apis.updateData(`${adminpath}/institution-status`, data).then((res) => res);

export const studentProposalList = (data) =>
  apis.getDatas(`${adminpath}/student-proposals`).then((res) => res);

export const admin_internship_applications_list = (page, per_page, filters = {}) => {
  const params = new URLSearchParams();
  params.set("page", page || 1);
  params.set("per_page", per_page || 10);
  if (filters.status) params.set("status", filters.status);
  return apis.getDatas(`${adminpath}/internship-applications?${params.toString()}`).then((res) => res);
};

export const superadmin_internship_applications_list = (page, per_page, filters = {}) => {
  const params = new URLSearchParams();
  params.set("page", page || 1);
  params.set("per_page", per_page || 10);
  if (filters.status) params.set("status", filters.status);
  return apis.getDatas(`${superadmin}/internship-applications?${params.toString()}`).then((res) => res);
};

export const admin_internship_applications_detail = (id) =>
  apis.getDatas(`${adminpath}/internship-applications/${id}`).then((res) => res);

export const superadmin_internship_applications_detail = (id) =>
  apis.getDatas(`${superadmin}/internship-applications/${id}`).then((res) => res);

export const admin_internship_application_verify = (id, data) =>
  apis.updateData(`${adminpath}/internship-applications/${id}/verify`, data).then((res) => res);

export const admin_internship_confirm_rankings = (data) =>
  apis.createData(`${adminpath}/internship-confirm-rankings`, data).then((res) => res);

export const admin_internship_accept_and_forward_rankings = (data) =>
  apis.createData(`${superadmin}/internship-approve-rankings`, data).then((res) => res);

export const admin_internship_revert_ranking = (data) =>
  apis.createData(`${adminpath}/internship-revert-ranking`, data).then((res) => res);

export const admin_internship_ranked_applications = (id) =>
  apis.getDatas(`${adminpath}/internship-applications/${id}/ranked`).then((res) => res);

export const superadmin_internship_ranked_applications = (id) =>
  apis.getDatas(`${superadmin}/internship-ranking-requests/${id}`).then((res) => res);

export const superadmin_internship_revert_rankings = (data) =>
  apis.createData(`${superadmin}/internship-revert-rankings`, data).then((res) => res);

export const studentProposaldetails = (data) =>
  apis.getDatas(`${adminpath}/proposal/${data}`).then((res) => res);

export const student_prop_status_update = (data) =>
  apis
    .createData(`${adminpath}/student-proposals-status`, data)
    .then((res) => res);

export const super_comp_delete = (data) =>
  apis.deleteData(`${superadmin}/company/${data}`).then((res) => res);
export const admin_csv = (data) =>
  apis.createData(`${adminpath}/upload-companies`, data).then((res) => res);

export const super_newcomp_delete = (data) =>
  apis
    .deleteData(`${superadmin}/application-delete/${data}`)
    .then((res) => res);

export const super_insti_delete = (data) =>
  apis.deleteData(`${superadmin}/institution/${data}`).then((res) => res);

export const studentInternList = (data) =>
  apis.getDatas(`${adminpath}/internship-proposals`).then((res) => res);
export const studentInterndetails = (data) =>
  apis.getDatas(`${adminpath}/intern-proposal/${data}`).then((res) => res);

export const studentintern_status_update = (data) =>
  apis
    .createData(`${adminpath}/internship-proposals-status`, data)
    .then((res) => res);

export const adminInternshipProposalStatusUpdate = (id, data) =>
  apis
    .createData(`${adminpath}/internship-proposals/${id}/status`, data)
    .then((res) => res);

export const certifyInternshipProposal = (id, formData) =>
  apis
    .createData(`${adminpath}/internship-proposals/${id}/status`, formData)
    .then((res) => res);

export const admin_intern_delete = (id) =>
  apis.deleteData(`${superadmin}/internship/${id}`).then((res) => res);

export const admin_student_prop_delete = (id) =>
  apis.deleteData(`${superadmin}/student-proposal/${id}`).then((res) => res);

export const upload_company_logo = (applicationId, formData) =>
  apis.createData(`${adminpath}/company/${applicationId}/logo`, formData).then((res) => res);

// Admin Internship Requests APIs
export const adminInternshipRequestsList = (page, per_page, filters = {}) => {
  const params = new URLSearchParams();
  params.set("page", page || 1);
  params.set("per_page", per_page || 10);
  if (filters.qualification_type) params.set("qualification_type", filters.qualification_type);
  if (filters.qualifications) params.set("qualifications", filters.qualifications);
  if (filters.streams) params.set("streams", filters.streams);
  if (filters.status) params.set("status", filters.status);
  return apis.getDatas(`${adminpath}/internship-requests?${params.toString()}`).then((res) => res);
};

export const adminInternshipRequestDetail = (id) =>
  apis.getDatas(`${adminpath}/internship-requests/${id}`).then((res) => res);

export const adminInternshipRequestStatusUpdate = (id, data) =>
  apis.createData(`${adminpath}/internship-requests/${id}/status`, data).then((res) => res);

export const adminInternshipRequestSubmitForAcceptance = (id, data) =>
  apis.updateData(`${adminpath}/internship-requests/${id}/submit-for-acceptance`, data).then((res) => res);

export const adminInternshipRequestInitialRejection = (id, data) =>
  apis.updateData(`${adminpath}/internship-requests/${id}/initial-rejection`, data).then((res) => res);

// SuperAdmin Internship Requests APIs
export const superadminInternshipRequestsList = (page, per_page, filters = {}) => {
  const params = new URLSearchParams();
  params.set("page", page || 1);
  params.set("per_page", per_page || 10);
  if (filters.qualification_type) params.set("qualification_type", filters.qualification_type);
  if (filters.qualifications) params.set("qualifications", filters.qualifications);
  if (filters.streams) params.set("streams", filters.streams);
  if (filters.status) params.set("status", filters.status);
  return apis.getDatas(`${superadmin}/internship-requests?${params.toString()}`).then((res) => res);
};

export const superadminInternshipRequestDetail = (id) =>
  apis.getDatas(`${superadmin}/internship-requests/${id}`).then((res) => res);

export const superadminInternshipRequestStatusUpdate = (id, data) =>
  apis.createData(`${superadmin}/internship-requests/${id}/status`, data).then((res) => res);

export const superadminInternshipRequestApprove = (id, data) =>
  apis.updateData(`${superadmin}/internship-requests/${id}/approve`, data).then((res) => res);

export const superadminInternshipRequestReject = (id, data) =>
  apis.updateData(`${superadmin}/internship-requests/${id}/reject`, data).then((res) => res);

export const internshipQualifications = () =>
  apis.getDatas(`${publicpath}/internship-qualifications`).then((res) => res);

// Bulk Email APIs
export const send_bulk_emails = (data) =>
  apis.createData(`${adminpath}/bulk-emails`, data).then((res) => res);

export const adminBulkEmailsList = (page, per_page, filters = {}) => {
  const params = new URLSearchParams();
  params.set("page", page || 1);
  params.set("per_page", per_page || 10);
  if (filters.status) params.set("status", filters.status);
  return apis
    .getDatas(`${adminpath}/bulk-emails?${params.toString()}`)
    .then((res) => res);
};

export const superadminBulkEmailsList = (page, per_page, filters = {}) => {
  const params = new URLSearchParams();
  params.set("page", page || 1);
  params.set("per_page", per_page || 10);
  if (filters.status) params.set("status", filters.status);
  return apis
    .getDatas(`${superadmin}/bulk-emails?${params.toString()}`)
    .then((res) => res);
};

export const adminBulkEmailDetail = (uuid, page) =>
  apis
    .getDatas(`${adminpath}/bulk-emails/${uuid}?page=${page || 1}`)
    .then((res) => res);

export const adminBulkEmailDelete = (uuid) =>
  apis.deleteData(`${adminpath}/bulk-emails/${uuid}`).then((res) => res);

export const superadminBulkEmailDetail = (uuid, page) =>
  apis
    .getDatas(`${superadmin}/bulk-emails/${uuid}?page=${page || 1}`)
    .then((res) => res);

export const superadminBulkEmailDelete = (uuid) =>
  apis.deleteData(`${superadmin}/bulk-emails/${uuid}`).then((res) => res);

export const superadminBulkEmailApprove = (uuid) =>
  apis.createData(`${superadmin}/bulk-emails/${uuid}/approve`, {}).then((res) => res);

export const superadminBulkEmailUpdate = (uuid, data) =>
  apis.createData(`${superadmin}/bulk-emails/${uuid}`, data).then((res) => res);

// Internship Doing APIs
export const adminInternshipsDoingList = (page, per_page, filters = {}) => {
  const params = new URLSearchParams();
  params.set("page", page || 1);
  params.set("per_page", per_page || 10);
  if (filters.status) params.set("status", filters.status);
  return apis.getDatas(`${adminpath}/internships-doing?${params.toString()}`).then((res) => res);
};

export const superadminInternshipsDoingList = (page, per_page, filters = {}) => {
  const params = new URLSearchParams();
  params.set("page", page || 1);
  params.set("per_page", per_page || 10);
  if (filters.status) params.set("status", filters.status);
  return apis.getDatas(`${superadmin}/internships-doing?${params.toString()}`).then((res) => res);
};

// Internship Completed APIs
export const adminInternshipsCompletedList = (page, per_page, filters = {}) => {
  const params = new URLSearchParams();
  params.set("page", page || 1);
  params.set("per_page", per_page || 10);
  if (filters.status) params.set("status", filters.status);
  return apis.getDatas(`${adminpath}/internships-completed?${params.toString()}`).then((res) => res);
};

export const superadminInternshipsCompletedList = (page, per_page, filters = {}) => {
  const params = new URLSearchParams();
  params.set("page", page || 1);
  params.set("per_page", per_page || 10);
  if (filters.status) params.set("status", filters.status);
  return apis.getDatas(`${superadmin}/internships-completed?${params.toString()}`).then((res) => res);
};

// Internship Absorbed APIs
export const adminInternshipsAbsorbedList = (page, per_page) => {
  const params = new URLSearchParams();
  params.set("page", page || 1);
  params.set("per_page", per_page || 10);
  return apis.getDatas(`${adminpath}/internships-absorbed?${params.toString()}`).then((res) => res);
};

export const superadminInternshipsAbsorbedList = (page, per_page) => {
  const params = new URLSearchParams();
  params.set("page", page || 1);
  params.set("per_page", per_page || 10);
  return apis.getDatas(`${superadmin}/internships-absorbed?${params.toString()}`).then((res) => res);
};

export const adminEvaluateInternshipProposal = (id, formData) =>
  apis.createData(`${adminpath}/internship-proposals/${id}/evaluate`, formData).then((res) => res);

// Login Analytics & Logs
export const admin_login_analytics = (params) =>
  apis.getDatas(`${adminpath}/login-analytics?${new URLSearchParams(params).toString()}`).then((res) => res);

export const admin_login_logs_list = (params) =>
  apis.getDatas(`${adminpath}/login-logs?${new URLSearchParams(params).toString()}`).then((res) => res);

export const admin_login_log_details = (id) =>
  apis.getDatas(`${adminpath}/login-logs/${id}`).then((res) => res);